export function getPeriodActsGenerate() {
    return axios({
        url: `api/period-acts-generate`,
        method: 'get',
    });
}
